import { useEffect } from 'react';
import { EnvService, PackageService } from 'namirasoft-core';
import { NSSpace, NSSpaceSizeType, NSButtonBlue, IBackgroundPropps } from 'namirasoft-site-react';
import Styles from './NSALoginPage.module.css';
import { NamirasoftAccountClient } from 'namirasoft-account-client';

export interface NSALoginPageProps
{
	title: string;
	logo: string;
	background: IBackgroundPropps;
}

let REACT_APP_BASE_URL_ACCOUNT_CONSOLE = new EnvService("REACT_APP_BASE_URL_ACCOUNT_CONSOLE").getString();
let client = new NamirasoftAccountClient(REACT_APP_BASE_URL_ACCOUNT_CONSOLE);

export function NSALoginPage(props: NSALoginPageProps) 
{
	useEffect(() =>
	{
		client.onLoggedin = () => { window.location.reload(); };
		client.onLoggedout = () => { window.location.reload(); };

		client.start();

		return () => { client.stop(); };

		// eslint-disable-next-line 
	}, []);

	return (
		<div
			style={{
				width: '100%',
				background: props.background?.image ? `url(${props.background?.image})` : "",
				backgroundSize: props.background?.size ?? "cover",
				backgroundAttachment: props.background?.attachment ?? "fixed"
			}}
		>
			<div className={`container ${Styles.nsa_login_page_container}`}>
				<div className={Styles.nsa_login_page_logo}>
					<img width={256} height={256} src={props.logo} alt={`${props.title} Logo`} />
				</div>
				<NSSpace size={NSSpaceSizeType.SMALL} />
				<div>
					<h1 className={Styles.nsa_login_page_title}>{props.title}</h1>
				</div>
				<NSSpace size={NSSpaceSizeType.LARGE} />
				<NSButtonBlue
					title="Login"
					onClick={{
						action: () =>
						{
							client.login();
						},
						showLoading: false
					}}
				/>
			</div>
			<span className={Styles.nsa_login_page_version}>Version: {PackageService.MainJson?.version}</span>
		</div>
	);
}